import {WidgetDescription} from '../../components/layout/widget/widget-description';
import {DEX_WALLET_WIDGET_TYPE_ID} from './dex-wallet-widget-type-id';
import {DexWalletWidgetComponent} from './dex-wallet-widget.component';
import {DexWalletWidgetImplementation} from './dex-wallet-widget.implementation';
import {DexWalletWidgetSettingsComponent} from './settings/dex-wallet-widget-settings.component';
import {DexWalletWidgetSettingsService} from './settings/dex-wallet-widget-settings.service';

export const DEX_WALLET_WIDGET_DESCRIPTION: WidgetDescription = {
    widgetTypeId:                DEX_WALLET_WIDGET_TYPE_ID,
    widgetLabel:                 'Assets',
    widgetImplementationType:    DexWalletWidgetImplementation,
    widgetComponentType:         DexWalletWidgetComponent,
    widgetSettingsServiceType:   DexWalletWidgetSettingsService,
    settingsSchema:              [
        {
            name: 'title',
            isShareable: false
        }
    ],
    hasGroupingSupport:          false,
    widgetSettingsComponentType: DexWalletWidgetSettingsComponent
};
